import { HomeNavigatorParamList, navigate, push } from "../navigators"
import { getRootStore } from "./root-store"

/**
 * A "modern" sleep statement.
 *
 * @param ms The number of milliseconds to wait.
 */
export const handleDeepLink = ({ url }) => {
  const { shrimpPriceStore } = getRootStore()

  if (url && ['/posts', '/kabar_udang'].find((key) => url.includes(key))) {
    const separator = ['/posts', '/kabar_udang'].find((key) => url.includes(key));
    const id = (url.split(separator)[1].split('?')[0] || '').replace('/', '');
    if (id === 'simulations') {
      navigate('App.Stack', 'Home.Stack', { screen: 'Home.Simulation.List' as keyof HomeNavigatorParamList });
    } else if (id === 'cycle_to_dos') {
      navigate('App.Stack', 'Home.Stack', { screen: 'Home.Activity.List' as keyof HomeNavigatorParamList });
    } else {
      const params = {
        data: {slug: id, title: ""}
      }
      navigate('App.Stack', 'Home.Stack', { screen: 'Home.News'})
      navigate('App.Stack', 'Home.Stack', { screen: 'Home.News.Detail', params })
    }
    return true;
  } else if (url && ['/diseases'].find((key) => url.includes(key))) {
    const separator = ['/diseases'].find((key) => url.includes(key));
    const params = {
      id: (url.split(separator)[1].split('?')[0] || '').replace('/', ''),
    };
    navigate('App.Stack', 'Home.Stack', { screen: 'Home.Disease' })
    navigate('App.Stack', 'Home.Stack', { screen: 'Home.Disease.Detail', params })
    return true;
  } else if (url && ['/shrimp_prices', '/harga_udang'].find((key) => url.includes(key))) {
    const separator = ['/shrimp_prices', '/harga_udang'].find((key) => url.includes(key));
    const params = {
      id: (url.split(separator)[1].split('?')[0] || '').replace('/', '')
    };
    shrimpPriceStore.getShrimpPrices().finally(() => {
      const shrimpPrice = shrimpPriceStore.shrimpPrices.find((s) => String(s.id) === String(params.id))
      if (shrimpPrice) {
        shrimpPriceStore.set('shrimpPriceId', shrimpPrice.id)
        navigate('App.Stack', 'Home.Stack', { screen: 'Home.ShrimpPrice.Detail' as keyof HomeNavigatorParamList })
      } else {
        navigate('App.Stack', 'Home.Stack', { screen: 'Home.ShrimpPrice.List' as keyof HomeNavigatorParamList });
      }
    })
    return true;
  } else if (url && url.includes('/notifications')) {
    navigate('App.Stack', 'Home.Stack', { screen: 'Home.Notifications' as keyof HomeNavigatorParamList });
    return true;
  } else if (url && url.includes('/chemical_predictions')) {
    navigate('App.Stack', 'Home.Stack', { screen: 'Home.MeasurementPrediction.Stack' as keyof HomeNavigatorParamList })
    return true;
  } else if (url && url.includes('/jala_web_view')) {
    const urlTemp = new URL(url);
    const openScreen = urlTemp.searchParams.get('open_screen')
    if (openScreen) {
      navigate('App.Stack', 'Home.Stack', {
        screen: openScreen as keyof HomeNavigatorParamList
      })
    } else {
      const uri = urlTemp.searchParams.get('open')
      const title = urlTemp.searchParams.get('title')
      const hideNavbar = urlTemp.searchParams.get('hide_navbar')
      const backgroundColor = urlTemp.searchParams.get('background_color')
      const backgroundBar = urlTemp.searchParams.get('background_bar')
      const statusBar = urlTemp.searchParams.get('status_bar')

      push('Home.Stack', {
        screen: 'Home.JalaWebView' as keyof HomeNavigatorParamList,
        params: { uri, title, hideNavbar, backgroundColor, backgroundBar, statusBar }
      });
    }
    return true;
  }

  return false;
}
